<template>
    <div class="cover"
         @click.self="closePlay">
        <div class="video_panel">
            <video ref="video"
                   controls
                   :src="video_url"
                   @ended="videoEnd()"></video>
        </div>
    </div>
</template>

<script>
export default {
    props: ['video_url', 'submit'],
    methods: {
        closePlay () {
            this.$refs.video.pause();
            this.$emit("closePlayer");
        },
        play () {
            this.$refs.video.play();
        },
        videoEnd () {
            if (this.submit) {
                this.$emit("submitPlayer");
            }
        }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.cover {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 1000;
    .video_panel {
        position: absolute;
        top: 50%;
        left: 0;
        width: 100%;
        height: 406px / $ppr;
        margin-top: -203px / $ppr;
        video {
            width: 100%;
            height: 100%;
        }
    }
}
</style>